import {
  ratingListResponseSchema,
  ratingSchema,
  submitRatingRequestSchema,
  type SubmitRatingRequest,
} from "@chotca/config";
import type { RequestContext } from "./http";
import { requestJson } from "./http";

export function createRatingsResource(ctx: RequestContext) {
  return {
    submitForPosting(postingId: string, body: SubmitRatingRequest) {
      const payload = submitRatingRequestSchema.parse(body);
      return requestJson(ctx, {
        method: "POST",
        path: `/postings/${postingId}/rating`,
        body: payload,
        dataSchema: ratingSchema,
        auth: true,
      });
    },

    listByUser(userId: string, cursor?: string, limit?: number) {
      const qs = new URLSearchParams();
      if (cursor) qs.set("cursor", cursor);
      if (limit) qs.set("limit", String(limit));
      const query = qs.toString();
      return requestJson(ctx, {
        method: "GET",
        path: `/users/${userId}/ratings${query ? `?${query}` : ""}`,
        dataSchema: ratingListResponseSchema,
        auth: true,
      });
    },

    listByOrg(orgId: string, cursor?: string, limit?: number) {
      const qs = new URLSearchParams();
      if (cursor) qs.set("cursor", cursor);
      if (limit) qs.set("limit", String(limit));
      const query = qs.toString();
      return requestJson(ctx, {
        method: "GET",
        path: `/orgs/${orgId}/ratings${query ? `?${query}` : ""}`,
        dataSchema: ratingListResponseSchema,
        auth: true,
      });
    },
  };
}
